import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CBNHero from "./components/CBNHero";
import CBNContent from "./components/CBNContent";
import CBNFormula from "./components/CBNFormula";
import CBNShopSection from "./components/CBNShopSection";
import CBNRelated from "./components/CBNRelated";
import CBNBottomCTA from "./components/CBNBottomCTA";

export default function CalmBedroomNeutrals() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CBNHero />
      <CBNContent />
      <CBNFormula />
      <CBNShopSection />
      <CBNRelated />
      <CBNBottomCTA />
      <Footer />
    </div>
  );
}
